import { useEffect, useState } from "react";

/**
 * Live viewport width in px, updated on resize.
 *
 * Exists because a fixed `min-width: Npx` media query can't answer "does this
 * table actually fit?" — that depends on how many columns the company has
 * configured, not on a breakpoint someone picked once. Callers sum their real
 * column widths and compare.
 *
 * Returns 0 until mounted so SSR and the first client render agree; callers
 * should treat 0 as "unknown" and fall back to their compact layout.
 */
export function useViewportWidth(): number {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const read = () => setWidth(window.innerWidth);
    read();
    window.addEventListener("resize", read);
    return () => window.removeEventListener("resize", read);
  }, []);

  return width;
}
